<template>
<div id="establishment-list" class="container-cap">
  <div v-if="error">
    <div class="row">
      <div class="col-xs-12 col-md-8 col-lg-6">
        <sui-error-panel id="loading-error">
          <template slot="title">Erreur de chargement !</template>
          <template slot="heading">
            Une erreur s'est produite pendant le chargement des établissements
            incrits.
          </template>
          Merci de vérifier votre connexion internet avant de réessayer.
        </sui-error-panel>
      </div>
    </div>
  </div>
  <div v-else-if="!loaded">
    <h2>Mes établissements inscrits à SPIADI {{current}}</h2>
    <hr />
    <div v-for="i in 4"
         :key="`loading-${current}-${i}`"
         class="col-lg-3 col-md-4 col-sm-6 open-button-container">
      <btn type="primary" block class="open-button" disabled>
        <sui-loading-text>Chargement</sui-loading-text>
      </btn>
    </div>
    <h2>Mes établissements inscrits à SPIADI {{current - 1}}</h2>
    <hr />
    <div v-for="i in 4"
         :key="`loading-${current - 1}-${i}`"
         class="col-lg-3 col-md-4 col-sm-6 open-button-container">
      <btn type="primary" block class="open-button" disabled>
        <sui-loading-text>Chargement</sui-loading-text>
      </btn>
    </div>
  </div>
  <div v-else>
    <h2 role="button" @click="collapse[current] = !collapse[current]">
      <span class="glyphicon glyphicon-plus" v-if="!collapse[current]"
            aria-hidden="true">
      </span>
      <span class="glyphicon glyphicon-minus" v-else
            aria-hidden="true">
      </span>
      Mes établissements inscrits à SPIADI {{current}}
    </h2>
    <hr />
    <collapse v-model="collapse[current]">
      <alert v-if="Object.keys(withoutModules).length > 0" type="warning">
        <h3>
          Établissements sans modules
        </h3>
        <p>
          Les établissements suivants ne sont inscrits à aucun module de
          surveillance ou d'observation des pratiques :
        </p>
        <p>
          <ul>
            <li v-for="(e, k) in withoutModules" :key="`no-modules-${k}`">
              {{ e }}
            </li>
          </ul>
        </p>
        <p>
          <strong>
            Le choix des modules de surveillance et d'observation des pratiques
            se fait dans l'espace SPIADI dédié à chaque établissement, accessible
            en cliquant sur les boutons ci-dessous.
          </strong>
        </p>
      </alert>
      <div class="row">
        <div v-for="s in surveillances[current]"
             class="col-lg-3 col-md-4 col-sm-6"
             :key="s.id">
          <div class="open-button-container">
            <btn :type="withoutModules[s.id] == null ? 'primary' : 'warning'"
               block class="open-button"
               @click="$router.push(`${current}/${s.id}`)">
              <strong>{{ s.establishment.name }}</strong>
            </btn>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-6">
          <div class="open-button-container">
            <btn type="success" block class="open-button"
                 @click="showSubscription = true">
              <strong>INSCRIRE UN ÉTABLISSEMENT</strong>
            </btn>
          </div>
        </div>
      </div>
    </collapse>
    <div v-for="y in previousYears" :key="`list-${y}`">
      <h2 role="button" @click="collapse[y] = !collapse[y]">
        <span class="glyphicon glyphicon-plus" v-if="!collapse[y]"
              aria-hidden="true">
        </span>
        <span class="glyphicon glyphicon-minus" v-else
              aria-hidden="true">
        </span>
        Mes établissements inscrits à SPIADI {{ y }}
      </h2>
      <hr/>
      <collapse v-model="collapse[y]">
        <div class="row">
          <div v-for="s in surveillances[y]"
               class="col-lg-3 col-md-4 col-sm-6"
               :key="s.id">
            <div class="open-button-container">
              <btn type="primary" block class="open-button"
                   @click="$router.push(`${y}/${s.id}`)">
                <strong>{{ s.establishment.name }}</strong>
              </btn>
            </div>
          </div>
          <div v-if="surveillances.length === 0" class="col-xs-12">
            <p>
              Aucun établissement inscrit.
            </p>
          </div>
        </div>
      </collapse>
    </div>
    <div>
      <h2 role="button" @click="collapse['2019'] = !collapse['2019']">
        <span class="glyphicon glyphicon-plus" v-if="!collapse['2019']"
              aria-hidden="true">
        </span>
        <span class="glyphicon glyphicon-minus" v-else
              aria-hidden="true">
        </span>
        Mes établissements inscrits à SPIADI 2019
      </h2>
      <hr/>
      <collapse v-model="collapse['2019']">
        <div class="row">
          <div class="col-xs-12">
            <alert type="warning">
              <h3>L'accès aux surveillance 2019 est temporairement désactivé</h3>
              <p>
                Afin d'uniformiser les pages de résultats et de produire des graphiques
                suivant l'évolution des taux dans le temps, les données 2019
                sont en cours d'adaptation.
              </p>
            </alert>
          </div>
          <div v-for="s in surveillances['2019']"
               class="col-lg-3 col-md-4 col-sm-6"
               :key="s.id">
            <div class="open-button-container">
              <btn type="primary" block class="open-button" disabled>
                <strong>{{ s.establishment.name }}</strong>
              </btn>
            </div>
          </div>
          <div v-if="surveillances['2019'].length === 0" class="col-xs-12">
            <p>
              Aucun établissement inscrit.
            </p>
          </div>
        </div>
      </collapse>
    </div>
  </div>
  <sui-establishment-add v-model="showSubscription"
                         :year="current"
                         :list="previousList"></sui-establishment-add>
</div>
</template>

<script>
import suiLoadingText from '@/sui/components/loadingtext'
import suiErrorPanel from '@/sui/components/errorpanel'
import suiEstablishmentAdd from '@/sui/components/establishment/add'

import { mapState, mapGetters } from 'vuex'

const survey = 'surveillance2019'
export default {
  name: 'establishments-list',

  data: function () {
    return {
      showSubscription: false,
      collapse: {
        '2026': true,
        '2025': true,
        '2024': false,
        '2023': false,
        '2022': false,
        '2021': false,
        '2020': false,
        '2019': false
      }
    }
  },

  computed: {
    ...mapState({
      surveillances: state => state.surveillances.all
    }),

    ...mapGetters({
      loaded: 'surveillances/loaded',
      error: 'surveillances/error',
      userId: 'user/id'
    }),

    previousYears: function () {
      return ['2025', '2024', '2023', '2022', '2021', '2020']
    },

    current: function () {
      return '2026'
    },

    previousList: function () {
      const result = []
      this.previousYears.forEach(
        y => {
          if (result.length === 0) {
            result.push(...this.surveillances[y].slice())
            return
          }

          this.surveillances[y].forEach(
            s => {
              const e = result.find(
                r => r.establishment.finess === s.establishment.finess
              )
              if (e == null) {
                result.push(s)
              }
            }
          )
        }
      )
      return result.sort(
        (a, b) => a.establishment.finess.localeCompare(b.establishment.finess)
      )
    },

    survey2019: function () {
      return this.$store.getters['user/surveyState'](survey)
    },

    withoutModules: function () {
      if (this.surveillances == null ||
          this.surveillances[this.current] == null) {
        return {}
      }
      const list = this.surveillances[this.current]
      const result = {}
      list.forEach(
        s => {
          const l = Object.keys(s.modules)
          if (l.length === 0 || (l.length === 1 && l[0] === 'results')) {
            result[s.id] = s.establishment.name
          }
        }
      )
      return result
    }
  },

  created () {
    this.$store.dispatch('surveillances/loadAll')
  },

  components: {
    'sui-loading-text': suiLoadingText,
    'sui-error-panel': suiErrorPanel,
    'sui-establishment-add': suiEstablishmentAdd
  }
}
</script>
<style scoped lang="less">
@import "~variables";

#establishment-list {
  h2 {
    color: @darker-base;
  }

  .open-button-container {
    padding: 1rem;
  }

  .open-button {
    white-space: normal;
    height: 7rem;
  }
}

#loading-error {
  margin-top: 2rem;
}

.alert h3 {
  margin-top: 0rem;
}
</style>
